import React from 'react';
import Reflux from 'reflux';
import PopoverMenu from 'shared/components/menus/popoverMenu.jsx';
import { OrderedMap, Map } from 'immutable';
import CuesheetStore from 'shared/flux/stores/cuesheet/CuesheetStore';
import PopoverStore from 'shared/flux/stores/PopoverStore';
import PopoverActions from 'shared/flux/actions/PopoverActions';
import PureRenderMixin from 'react-pure-render/mixin';
import ColumnMenuMixin from 'main/components/show/cuesheet/columnHeaderCell/columnMenuMixin';
import GridColumnMenuHelper from 'main/components/show/grid/columnHeaderCell/columnMenuHelper';
import CuesheetColumnActions from 'flux/actions/cuesheet/CuesheetColumnActions';
import keyIn from 'shared/lib/immutable/keyIn';
import role from 'shared/lib/role';

export default React.createClass({
  displayName: 'NoteColumnMenu',

  mixins: [
    Reflux.connect(PopoverStore, 'popoverVisibility'),
    PureRenderMixin,
    ColumnMenuMixin,
    Reflux.connectFilter(CuesheetStore, 'userSettings', (st) =>
      st.get('userSettings'),
    ),
    Reflux.connectFilter(CuesheetStore, 'showSettings', (st) => {
      if (!st.get('show')) return null;
      return st
        .get('show')
        .filter(
          keyIn(
            'displayType',
            'displayItemNumbers',
            'displayStartTime',
            'displayDuration',
            'displayPresetDuration',
            'displayItemTitles',
            'displayItemDescriptions',
          ),
        );
    }),
  ],

  propTypes: {
    user: React.PropTypes.object,
  },

  contextTypes: {
    router: React.PropTypes.object.isRequired,
  },

  render() {
    const showMenu = this.state.popoverVisibility.get(this._getColumnId());

    if (!this.state.showSettings) return null;

    return (
      <PopoverMenu
        grid
        className="grid-note-column-menu"
        config={this._getConfigData()}
        show={showMenu}
      />
    );
  },

  _getWidthItems() {
    return GridColumnMenuHelper.getWidthColumnOptions(
      true,
      this.props.currentWidth,
      (width) => CuesheetColumnActions.updateNoteColumnWidth(width),
    );
  },

  _getConfigData() {
    let { teamId, eventId } = this.context.router.state.params;

    let hasEventAdmin = role.hasEventAdminRole(
      this.props.user,
      teamId,
      eventId,
    );

    return hasEventAdmin
      ? this._getConfigDataAdmin()
      : this._getConfigDataNonAdmin();
  },

  _getConfigDataNonAdmin() {
    let id = this._getColumnId();

    let widthItems = this._getWidthItems();
    let userSettings = this.state.userSettings;

    let displayNotes =
        userSettings && !userSettings.getIn(['noteColumn', 'hidden']),
      displayNotesVerb = displayNotes ? 'Hide' : 'Show';

    let items = OrderedMap({
      toggleNote: GridColumnMenuHelper.getNoteColumnOption(
        true,
        displayNotes,
        displayNotesVerb,
      ),
    }).concat(widthItems);

    return _buildMenuConfig(id, items);
  },

  _getConfigDataAdmin() {
    let id = this._getColumnId();

    let widthItems = this._getWidthItems();

    let addDivider = widthItems.size ? true : false;

    let items = GridColumnMenuHelper.getUtilityColumnOptions(
      this.context,
      this.state,
      addDivider,
      this.props.user,
    ).concat(widthItems);

    return _buildMenuConfig(id, items);
  },

  _getColumnId() {
    return `util-column-${this.props.id}`;
  },
});

const _buildMenuConfig = (id, items) => {
  return Map({
    id,
    noCaret: false,
    icon: 'angle-down',
    placement: 'bottom',
    onClick: () => PopoverActions.show(id),
    onHide: () => PopoverActions.hide(id),
    items,
  });
};
